export default "__VITE_ASSET__d2aa4e0d__"